<template>
    <div class="userlist-wrap">
       <el-table :data="orderlist">
            <el-table-column label="编号"  prop="order_no"></el-table-column>
            <el-table-column label="标题"  prop="user.nickName"></el-table-column>
            <el-table-column label="内容"  prop="pay_type.text"></el-table-column>
            <el-table-column label="金额"  prop="pay_price"></el-table-column>
            <el-table-column label="时间"  prop="pay_price"></el-table-column>
       </el-table>
       <div class="pagination" slot="footer">
        <el-pagination 
            @size-change="handleSizeChange" 
            @current-change="handleCurrentChange" 
            background 
            :current-page="searchForm.curPage"
            :page-size="searchForm.pageSize" 
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="searchForm.total">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import ChannelApi from '@/api/channel.js';
export default {
    data(){
        return{
            searchForm:{
                curPage:1,
                pageSize:10,
                total:0
            },
            orderlist:[]
        }
    },
    created(){
        // this.getUserList()
    },
    methods:{
        handleCurrentChange(val){
            this.searchForm.curPage = val;
        },
        handleSizeChange(val){
            this.searchForm.pageSize = val;
        },
        getUserList(){
            ChannelApi.orderList({}, true).then(res=>{
                console.log('orderlist', res);
                const {data, total} = res.data.list
                this.orderlist = data
                this.searchForm.total = total
            })
        },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/channel/user/daili/walletDetails.vue